// state
import axios from "axios";
const state = {
  loader: false,
  drawer: null,
  auth: {
    token: null,
    name: null,
    id: null,
    picture: null,
    menu: []
  }
};

// getters
const getters = {
  isAuthenticated: state => !!state.auth.token
};

// actions
const actions = {
  login({ commit }, { username, password }) {
    return new Promise((resolve, reject) => {
      axios
        .post("/login", {
          username: username,
          password: password,
          sourcePortal: "ADMIN"
        })
        .then(response => {
          if (response.data.token) {
            commit("SET_USER", response.data);
          } else {
            commit("RESET_USER");
          }
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  logout({ commit }) {
    return new Promise(resolve => {
      commit("RESET_USER");
      resolve();
    });
  }
};

// mutations
const mutations = {
  SET_USER(state, user) {
    state.auth = user;
  },
  RESET_USER(state) {
    state.auth = {
      token: null,
      name: null,
      username: null,
      menu: [],
      id: null
    };
  },
  TOGGLE_DRAWER(state) {
    state.drawer = !state.drawer;
  },
  SET_DRAWER(state, val) {
    state.drawer = val;
  },
  SET_LOADER(state, loader) {
    state.loader = loader;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
